module.exports = __webpack_public_path__ + "static/media/playEpisode.14190aa8.svg";